import type { AssetPropertiesListItem } from './asset-properties-list';

export const splitEmptyValues = (items: AssetPropertiesListItem[]) =>
  items.reduce<[AssetPropertiesListItem[], AssetPropertiesListItem[]]>(
    ([withVals, withoutVals], item) => {
      item.fieldValue && item.fieldValue !== ''
        ? withVals.push(item)
        : withoutVals.push(item);
      return [withVals, withoutVals];
    },
    [[], []]
  );
